export const WCA_AUTH_SUCCESS_SEARCH_PARAM = 'wcaAuthSuccess'
